import { FirebaseError } from 'firebase/app';
import { getErrorMessage } from '@/shared/utils/errors';

/**
 * Gestion centralisée des erreurs Firebase
 * Convertit les codes d'erreur Firebase en messages utilisateur compréhensibles
 */
export const handleFirebaseError = (error: unknown): string => {
  if (error instanceof FirebaseError) {
    switch (error.code) {
      case 'permission-denied':
        return "Vous n'avez pas les permissions nécessaires";
      case 'unavailable':
        return 'Le service est temporairement indisponible';
      case 'unauthenticated':
        return 'Vous devez être connecté pour effectuer cette action';
      case 'not-found':
        return "L'élément recherché n'existe pas";
      case 'already-exists':
        return "Cet élément existe déjà";
      case 'invalid-argument':
        return 'Les données fournies sont invalides';
      case 'deadline-exceeded':
        return 'La requête a pris trop de temps, veuillez réessayer';
      case 'resource-exhausted':
        return 'Trop de requêtes, veuillez réessayer plus tard';
      case 'failed-precondition':
        return "L'opération ne peut pas être effectuée dans l'état actuel";
      case 'aborted':
        return "L'opération a été annulée";
      case 'out-of-range':
        return 'Les valeurs fournies sont hors limites';
      case 'unimplemented':
        return "Cette fonctionnalité n'est pas encore implémentée";
      case 'internal':
        return 'Une erreur interne est survenue';
      case 'data-loss':
        return 'Une perte de données a été détectée';
      case 'storage/unauthorized':
        return "Vous n'avez pas l'autorisation d'accéder à ce fichier";
      case 'storage/canceled':
        return "L'upload a été annulé";
      case 'storage/unknown':
        return 'Une erreur inconnue est survenue lors du stockage';
      case 'storage/invalid-format':
        return 'Le format du fichier est invalide';
      case 'storage/invalid-checksum':
        return 'Le fichier est corrompu';
      case 'auth/user-not-found':
        return "L'utilisateur n'existe pas";
      case 'auth/wrong-password':
        return 'Le mot de passe est incorrect';
      case 'auth/email-already-in-use':
        return "Cet email est déjà utilisé";
      case 'auth/weak-password':
        return 'Le mot de passe est trop faible';
      case 'auth/invalid-email':
        return "L'adresse email est invalide";
      case 'auth/network-request-failed':
        return 'Erreur de connexion réseau';
      default:
        return error.message || 'Une erreur est survenue';
    }
  }
  
  // Si ce n'est pas une erreur Firebase, utiliser la fonction générique
  return getErrorMessage(error);
};

